export default "__VITE_ASSET__CrMb2rst__";